"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GtmNoScriptInitializer = void 0;
const react_1 = __importDefault(require("react"));
const tracking_utils_1 = require("./tracking.utils");
function GtmNoScriptInitializer() {
    if (!tracking_utils_1.gtmQueryString)
        return null;
    return (react_1.default.createElement("noscript", null,
        react_1.default.createElement("iframe", { src: `https://www.googletagmanager.com/ns.html?l=duckTape&${tracking_utils_1.gtmQueryString}`, title: "gtm-script", height: "0", width: "0", style: { display: 'none', visibility: 'hidden' } })));
}
exports.GtmNoScriptInitializer = GtmNoScriptInitializer;
//# sourceMappingURL=GtmNoScriptInitializer.js.map